import joint from 'jointjs';

import { zoomInOnSourceOrTargetBox } from './zoom';


export function linkFactory(paper, attributes) {
  const link = new joint.shapes.devs.Link({
    z: 5,
    attrs: {
      '.marker-target': { d: 'M 10 0 L 0 5 L 10 10 z' },
      '.connection': { 'stroke-width': 2 },
      '.marker-arrowhead-group-source .marker-arrowhead': { d: 'M 0 0' },
      '.marker-arrowhead-group-target .marker-arrowhead': { d: 'M 10 0 L 0 5 L 10 10 z' },
    }
  });
  link.set('router', customRouter);
  link.set('connector', customConnector);

  if (attributes) {
    link.set(attributes);
  }
  link.on('change:target', () => {
    const target = link.get('target');
    if (target && target.id) {
      const targetCellView = link.graph.getCell(target.id).findView(paper);
      if (targetCellView.updateValidity) {
        targetCellView.updateValidity();
      }
    }
  });
  return link;
}


// This router is based on the oneSide router, but has side right for source and side left for target.
function customRouter(vertices, opt, linkView) {

  const padding = 40;
  let routePointsResult;

  // LinkView contains cached source and target bboxes.
  // Note that those are Geometry rectangle objects.
  const sourceBBox = linkView.sourceBBox;
  const targetBBox = linkView.targetBBox;
  const sourcePoint = sourceBBox.center();
  const targetPoint = targetBBox.center();

  // Joint normal router can handle fairly well the cases where target box is to the right of source box.
  if (targetPoint.x - sourcePoint.x > 30) {
    routePointsResult = joint.routers.normal(vertices, opt, linkView);
  } else {
    // move the points from the center of the element to outside of it.
    sourcePoint.x += (sourceBBox.width / 2 + padding);
    targetPoint.x += -1 * (targetBBox.width / 2 + padding);
    routePointsResult = [sourcePoint].concat(vertices, targetPoint);
  }
  return routePointsResult;

}

// The 'smooth' connector doesn't work well for cases where the custom router above adds a vertice
function customConnector(sourcePoint, targetPoint, vertices) {

  let svgPathResult;

  // customRouter can insert 2 vertices. Custom connector works with those vertices but not with arbitrary ones.
  if (targetPoint.x - sourcePoint.x > 30 || (vertices && vertices.length > 2)) {
    svgPathResult = joint.connectors.smooth(sourcePoint, targetPoint, vertices);
  } else {
    const midPoint = {
      'x': (sourcePoint.x + targetPoint.x) / 2,
      'y': (sourcePoint.y + targetPoint.y) / 2
    };
    const controlPoint = {
      'x': sourcePoint.x + 250,
      'y': sourcePoint.y
    };

    // svg Bezier curves
    svgPathResult = [
      'M', sourcePoint.x, sourcePoint.y,
      'Q', controlPoint.x, controlPoint.y, midPoint.x, midPoint.y,
      'T', targetPoint.x, targetPoint.y,
    ].join(' ');
  }
  return svgPathResult;
}


/**
 * Draws label on links going out of graph elements whose ids are present in the given metrics data structure,
 * displaying the corresponding click statistics.
 * 
 * {
 *  <element_id>: {
 *    numberOfClics: 12345,
 *    percentageOfBox: 24
 *  },
 *  ...
 * }
 */
export function addLinksLabelFromMetrics(graph, metrics) {
  graph.getLinks().forEach(link => {
    const sourceId = link.get('source').id;
    if (sourceId in metrics) {
      const labelText = metrics[sourceId].numberOfClics + ' (' + metrics[sourceId].percentageOfBox + '%)';
      link.label(0, {
        'position': 60,
        'attrs': {
          'rect': {
            'fill': 'white',
            'stroke': 'black',
            'stroke-width': 2,
            'ref': 'text',
            'refHeight': 10,
            'refWidth': 10,
            'refX': -5,
            'refY': -5
          },
          'text': {
            'fill': '#0072c6',
            'text': labelText
          }
        }
      });
    } else {
      link.prop('labels', []);
    }
  });
}


export function removeAllLinksLabels(graph) {
  graph.getLinks().forEach(link => link.prop('labels', []));
}


/**
 * Converts the raw number of clicks returned by the backend 
 * to a datastructure for the function addLinksLabelFromMetrics
 * ()
 */
export function buildMetricsForLinkLabels(graph, scenarioTotalClicks) {
  const metrics = {};
  graph.getElements()
    .filter(element => element.get('isBoxType') && element.get('embeds')) // embeds is undefined instead of [] if nothing si embeded in the box
    .forEach(box => addMetricsForBox(box, scenarioTotalClicks, metrics));
  return metrics;
}

function addMetricsForBox(box, scenarioTotalClicks, metrics) {
  let totalForBox = 0;
  box.get('embeds').forEach(boxItemId => {
    if (scenarioTotalClicks[boxItemId]) {
      totalForBox += scenarioTotalClicks[boxItemId];
    }
  });
  // only build the metrics if we have at least one clic on one child
  // (this will avoid displaying "0" labels on links going out of boxes that can't be clicked, like 'message alone' boxes)
  if (totalForBox > 0) {
    box.get('embeds').forEach(boxItemId => {
      const clicksOnItem = scenarioTotalClicks[boxItemId] || 0; // the backend probably won't include items without clicks
      metrics[boxItemId] = {
        'numberOfClics': clicksOnItem,
        'percentageOfBox': Math.round(100 * clicksOnItem / totalForBox)
      };
    });
  }
}


const linkDropdownMenu = [
  {
    type: 'source',
    label: 'parameters/quick-replies/link_dropdown/zoom-in-on-source',
    enabled: true
  },
  {
    type: 'destination',
    label: 'parameters/quick-replies/link_dropdown/zoom-in-on-dest',
    enabled: true
  },
  {
    id: 'delete-link',
    type: 'delete',
    label: 'parameters/quick-replies/link_dropdown/delete-link',
    textColor: 'red',
    enabled: true
  }
];

export function initLinkDropdown($scope, $compile) {
  $('dropdown-box-menu.link-dropdown').remove(); // Remove previously appended elements

  $scope.menuIcon = 'arrow_drop_down_circle';
  $scope.menuItems = linkDropdownMenu;
  const el = $compile('<dropdown-box-menu class="link-dropdown" menu-icon="menuIcon" menu-items="menuItems"></dropdown-box-menu>')($scope);
  $(el).appendTo('body');
}

export function showLinkDropdown(cellview, evt, paper, $myholder) {

  linkDropdownMenu.forEach(e => {
    e.onClick = () => handleLinkDropdownClick(cellview, paper, $myholder, e.type);
  });

  const el = $('dropdown-box-menu.link-dropdown');
  el.css({
    'left': evt.clientX - el.outerWidth(),
    'top': evt.clientY - el.outerHeight(),
  });

  el.find('.md-icon-button').trigger('click');   // Trigger click on dropdown icon

  // Used only for twitter special case for now - Question box linked with Get Started
  if (cellview.targetView.model.get('can_be_deleted') == false) {
    $('#delete-link').prop('disabled', true).css('opacity', 0.5);
  } else {
    $('#delete-link').prop('disabled', false).css('opacity', 1);
  }

}

function handleLinkDropdownClick(cellview, paper, $myholder, type) {
  if (type == 'source' || type == 'destination') {
    const scale = 1.15;  // Zoom scale for the box
    zoomInOnSourceOrTargetBox(scale, cellview, paper, $myholder, type);
  }
  else {
    cellview.model.remove();
  }
}